// Module
var code = "<div class=\"front-desk flex layout-row\">\n    <div ui-view name=\"agenda\" class=\"flex layout-row\"></div>\n    <div ui-view name=\"practice\" class=\"flex-30 layout-row\" mn-acl='{\"action\": \"get\", \"resource\": \"entry\"}'></div>\n</div>\n";
// Exports
module.exports = code;